import { useLearningUiTranslation } from '@features/learning/shared/use-learning-ui-translation'
import { useMemo, useState } from 'react'
import type { FlashcardGameTemplateProps } from '../template-types'
import { compareFlashcardAnswer } from '../session-factory'
import { playLearningFeedbackAudio } from '@features/learning/shared/learning-feedback-audio'
import { Field, FieldLabel, LmsButton, LmsInput } from '@shared/ui'
import {
  LearningTemplateContinueActions,
  LearningTemplateExerciseFrame,
} from '@features/learning/shared/templates'
import '../flashcard-game.css'

export function Template3({
  onContinue,
  prompt,
}: FlashcardGameTemplateProps) {
  const ui = useLearningUiTranslation()
  const [value, setValue] = useState('')
  const [result, setResult] = useState<'correct' | 'incorrect' | null>(null)
  const shuffledLetters = useMemo(
    () => prompt.shuffledLetters ?? [],
    [prompt.shuffledLetters],
  )

  const handleCheckAnswer = () => {
    const nextResult = compareFlashcardAnswer({
      actual: value,
      expected: prompt.answerText ?? '',
    })
      ? 'correct'
      : 'incorrect'

    setResult(nextResult)
    playLearningFeedbackAudio(nextResult)
  }

  return (
    <LearningTemplateExerciseFrame
      className="flashcardGameTemplate"
      questionText={prompt.question}
      sourceOwner="flashcards"
    >
      <div className="flashcardGameLetterList">
        {shuffledLetters.map((letter, index) => (
          <span className="flashcardGameLetterTile" key={`${letter}-${index}`}>
            {letter}
          </span>
        ))}
      </div>

      <Field>
        <FieldLabel htmlFor="flashcard-template-3-answer">
          {ui("Your answer")}</FieldLabel>
        <LmsInput
          id="flashcard-template-3-answer"
          onChange={(event) => {
            setValue(event.target.value)
          }}
          value={value}
        />
      </Field>

      {result ? (
        <LearningTemplateContinueActions
          incorrectReviewText={prompt.answerText ?? null}
          incorrectReviewTranslationText={prompt.answerTranslation ?? null}
          onContinue={onContinue}
          result={result}
        />
      ) : (
        <LmsButton
          className="flashcardGameCheckAction"
          disabled={!value.trim()}
          onClick={handleCheckAnswer}
          variant="primary"
        >
          {ui("Check answer")}</LmsButton>
      )}
    </LearningTemplateExerciseFrame>
  )
}
